type ThrottledCallGenerator = (fn: CallableFunction) => void;

export function throttledCallGenerator(delay: number): ThrottledCallGenerator {
    let lastCall = 0;

    return (fn: CallableFunction) => {
        const now = Date.now();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        fn();
    };
}
